import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { ConDesignItemLite } from "../../types/ConDesignItem";
import { trackHubspotPageView } from "../../utils/hubspotUtils";

interface ConDesignItemProps {
  conDesignItem: ConDesignItemLite;
  setSelectedItem: (item: ConDesignItemLite) => void;
  isAuthenticated: boolean;
  redirectUri: string;
  source: string;
}
const ConDesignItem = ({ conDesignItem, setSelectedItem, isAuthenticated, redirectUri, source }: ConDesignItemProps) => {
  const { itemId } = useParams();
  const navigate = useNavigate();

  const getEventName = (baseEvent: string) => {
    if (source) {
      return `cl_${source}_item_${baseEvent}`;
    }

    return "cl_design_item_clicked";
  };

  const handleItemNavigation = (item: ConDesignItemLite) => {
    if (isAuthenticated) {
      window.dataLayer.push({
        "event": getEventName("clicked"),
      });
      localStorage.setItem("detailDesignItem", JSON.stringify(item));
      trackHubspotPageView(redirectUri)
      navigate(redirectUri);
    } else {
      window.dataLayer.push({
        "event": "cl_selection_not_logged_click",
      });
      setSelectedItem(item);
    }
  };

  return (
    <div
      className={`ConDesignItem ${itemId === conDesignItem.id ? "active" : ""}`}
      onClick={() => handleItemNavigation(conDesignItem)}
    >
      <img
        src={conDesignItem.pictureUrl}
        className="ConDesignItem--image"
        alt="connection thumbnail"
      />
    </div>
  );
};

export default ConDesignItem;
